/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ImportStatus = {
    Pending: 'Pending',
    Processing: 'Processing',
    Completed: 'Completed',
    Failed: 'Failed',
} as const;
export type ImportStatus = typeof ImportStatus[keyof typeof ImportStatus];

